import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { NgxMaskModule } from "ngx-mask";
import { MaterialModule } from "src/app/material-module";
import { AlertModule } from "src/app/shared/components/alert/alert.module";
import { SpinnerAngularmaterialModule } from "src/app/shared/components/spinner-angularmaterial/spinner-angularmaterial.module";
import { ApplicationPipesModule } from "src/app/shared/pipes/application-pipes.module";

import { ColetorModule } from "../coletor/coletor.module";
import { CpfModalModule } from "../cpf-modal/cpf-modal.module";
import { DoadorModule } from "../doador/doador.module";
import { TecidosCaptadosModule } from "../tecidos-captados/tecidos-captados.module";
import { TecidosModule } from "../tecidos-captados/tecidos/tecidos.module";
import { TriagemModule } from "../triagem/triagem.module";
import { ConfirmacaoComponent } from "./confirmacao/confirmacao.component";
import { DadosFormRoutingModule } from "./dados-form-routing.module";
import { DadosFormComponent } from "./dados-form.component";

@NgModule({
  declarations: [DadosFormComponent, ConfirmacaoComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    AlertModule,
    SpinnerAngularmaterialModule,
    DadosFormRoutingModule,
    FormsModule,
    NgxMaskModule,
    RouterModule,
    HttpClientModule,
    ColetorModule,
    TriagemModule,
    DoadorModule,
    TecidosCaptadosModule,
    TecidosModule,
    CpfModalModule,
    ApplicationPipesModule,
  ],
})
export class DadosFormModule {}
